"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyError = exports.assertWithLog = exports.assertThenReturn = exports.assert = void 0;
const axios_1 = __importDefault(require("axios"));
function assert(value, errMsg) {
    if (!value) {
        throw new Error(`Assertion failed: ${errMsg}`);
    }
}
exports.assert = assert;
function assertThenReturn(value, errMsg) {
    if (!value) {
        throw new Error(`Assertion failed: ${errMsg}`);
    }
    return value;
}
exports.assertThenReturn = assertThenReturn;
const assertWithLog = (condition, errMsg) => {
    if (!condition) {
        console.error(`Assertion failed: ${errMsg}`);
    }
};
exports.assertWithLog = assertWithLog;
const STACK_LENGTH = 200;
const stringifyStack = (stack) => {
    if (!stack) {
        return "";
    }
    const suffix = stack.length > STACK_LENGTH ? "..." : "";
    return stack.substring(0, STACK_LENGTH - suffix.length) + suffix;
};
function stringifyError(e) {
    const error = e;
    if (error === undefined) {
        return "undefined";
    }
    else if (error instanceof AggregateError) {
        const errorMessages = error.errors.map(stringifyError);
        return `AggregateError: ${error.message}, errors: ${errorMessages.join("; ")}`;
    }
    else if (axios_1.default.isAxiosError(error)) {
        return JSON.stringify(error.response?.data) + stringifyStack(error.stack);
    }
    else if (error instanceof Error) {
        return stringifyStack(error.stack);
    }
    else if (typeof error.toJSON === "function") {
        return JSON.stringify(error.toJSON());
    }
    else {
        return `Error couldn't be handled by the stringifyError function: ${String(e)}`;
    }
}
exports.stringifyError = stringifyError;
//# sourceMappingURL=errors.js.map